module.exports = __webpack_public_path__ + "static/media/logo-baby-squared-500px.56e06eeb.png";